import axios from "../axios";

export function checkEnvironmentCreation(email) {
    return axios.get(`health/${email}`).then(({data}) => data);
}
